import type { Middleware } from 'redux';
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { bootstrapActionTypes } from '@makemydeal/dr-shared-store';

import { configureDdj } from './config';

let cachedDdjSelectors: ReturnType<typeof configureDdj> | undefined;

// Exported for testing
export const ddjMiddlewareClearCache = () => (cachedDdjSelectors = undefined);

/**
 * DDJ middleware for Sales Check-In.
 *
 * Injects SCI's state readers into the DDJ activity on bootstrap. Until this
 * runs, the activity falls back to its uninitialized selectors — DDJPreloader is
 * mounted at the shell level and so renders before BOOTSTRAP_SUCCESS, at which
 * point there is no deal to read anyway.
 */
export const ddjMiddleware: Middleware = (_store) => (next) => (action: AnyFSA) => {
    const result = next(action);

    switch (action.type) {
        case bootstrapActionTypes.BOOTSTRAP_SUCCESS: {
            if (!cachedDdjSelectors) {
                cachedDdjSelectors = configureDdj();
            }
            break;
        }
    }

    return result;
};
